<template>
  <div class="text-14px page-box">
    <van-image class="insurance-bg" :src="insuranceBg" width="100%" />
    <div class="page-content">
      <div class="rounded-8px bg-white mx-12px">
        <div class="text-15px pl-16px pt-16px font-500 mb-4px">保障状态</div>
        <div class="px-4px">
          <van-steps :active="active" direction="vertical" active-color="#000000">
            <van-step v-for="(item, index) in stepsData" :key="index">
              <div>
                <div class="flex justify-between">
                  <div class="font-500">{{ item.statusTxt }}</div>
                  <div class="text-999 text-12px">{{ item.statusTime }}</div>
                </div>
                <div class="mt-10px">{{ item.statusDesc }}</div>
              </div>
            </van-step>
          </van-steps>
        </div>
      </div>
      <div class="rounded-8px bg-white m-12px p-16px item-box">
        <div class="text-15px font-500 mb-14px">保障内容</div>
        <div class="text-999 text-13px leading-22px">
          如订单在发货后90天内申请退换货，审核通过后可补贴运费，实际补贴将按照保险公司理赔标准给予赔付。<span
            style="color: #507afd"
            >一笔订单仅理赔一次。</span
          >
        </div>
      </div>
      <div class="rounded-8px bg-white m-12px px-16px text-13px item-box">
        <template v-for="(item, index) in secureContent" :key="index">
          <!-- <div v-if="index" class="van-hairline--bottom"></div> -->
          <div class="flex justify-between items-center py-16px">
            <div class="text-999">{{ item.label }}</div>
            <div>{{ item.value }}</div>
          </div>
        </template>
      </div>
      <div class="rounded-8px bg-white m-12px p-16px item-box">
        <div class="text-15px font-500 mb-14px">理赔流程</div>
        <div class="flex items-center justify-between px-4px">
          <template v-for="(item, index) in flowContent" :key="index">
            <van-icon v-if="index" :name="flowArrowIcon" :size="transPxToRem(12)" />
            <div class="text-center">
              <div class="mx-auto w-48px h-48px rounded-full flex justify-center items-center bg-F7F8FA">
                <van-icon :name="item.icon" :size="transPxToRem(24)" />
              </div>
            </div>
          </template>
        </div>
        <div class="flex items-center justify-between text-center mt-8px">
          <div class="text-999 text-12px leading-16px w-60px h-32px" v-for="(item, index) in flowContent" :key="index">
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="rounded-8px bg-white m-12px p-16px item-box">
        <div class="text-15px font-500 mb-14px">商品信息</div>
        <div v-for="(item, index) in goodsList" :key="item.goodsId" :class="{ 'mt-12px': Boolean(index), flex: true }">
          <van-image class="w-80px h-80px rounded-4px" :src="item.goodsLogo" />
          <div class="flex flex-col ml-12px flex-1 justify-between">
            <div class="text-15px w-230px van-multi-ellipsis--l2">{{ item.goodsName }}</div>
            <div class="w-full flex justify-between mt-4px text-999">
              <div v-html="setSpecName(item)"></div>
              <div>x{{ item.buyNumber }}</div>
            </div>
            <div class="w-full mt-12px leading-14px">¥{{ item.price }}</div>
          </div>
        </div>
      </div>
      <div class="fixIphonex"></div>
    </div>
  </div>
</template>
<script setup>
import { transPxToRem } from '@/utils'
import flowArrowIcon from '@/assets/img/step.png'
import returnGoodsIcon from '@/assets/img/return_goods.png'
import logisticsIcon from '@/assets/img/logistics.png'
import receiveGoodsIcon from '@/assets/img/receive_goods.png'
import insuranceBg from '@/assets/img/insurance-bg.png'
import payIcon from '@/assets/img/pay.png'
import { changeNumToHan } from '@/utils'
import { Image as vanImage, Icon as vanIcon, Steps as vanSteps, Step as vanStep } from 'vant'
import { getInsuranceDetail, getOrderDetail } from '@/api/order'
import { useRoute } from 'vue-router'
// import { setSpecName } from '../order/orderSpec'
import { ref, onMounted } from 'vue'
const {
  query: { orderId }
} = useRoute()
const active = ref(0)
const flowContent = ref([
  {
    icon: returnGoodsIcon,
    label: '申请退换货'
  },
  {
    icon: logisticsIcon,
    label: '协商同意寄回商品'
  },
  {
    icon: receiveGoodsIcon,
    label: '卖家收货退换货成功'
  },
  {
    icon: payIcon,
    label: '理赔成功'
  }
])
const secureContent = ref([
  {
    label: '保障额度',
    value: '',
    key: 'indemnityTips'
  },
  {
    label: '保费',
    value: '卖家赠送',
    key: 'premium'
  },
  {
    label: '保险公司',
    value: '众安保险',
    key: 'providerName'
  }
])
const stepsData = ref([])

const setSpecName = row => {
  if (row.specNames.length) {
    const arr = row.specNames?.map(str =>
      str
        .split(',')
        ?.map(val => val.split(':')[1])
        .join(',')
    )
    if (row.activityType === 1) {
      return arr
        ?.map((str, i) => `第${changeNumToHan(i + 1)}件：${str}${row.specNames.length - 1 === i ? '' : '<br/>'}`)
        .join('')
    } else return arr.join(',')
  }
  return ''
}

const getDetail = async () => {
  try {
    const resData = await getInsuranceDetail({ orderId, withLog: true })
    if (resData) {
      stepsData.value = resData.insuranceLog
      secureContent.value.forEach(item => {
        if (item.key === 'premium') {
          if (resData.obtainWay === 1) {
            item.value = resData.obtainWayTxt
          } else {
            item.value = resData.serviceFee
          }
        } else {
          item.value = resData[item.key]
        }
      })
    }
  } catch {}
}

const goodsList = ref([])
const getGoodsList = async () => {
  try {
    const resData = await getOrderDetail({ orderId })
    if (resData) {
      goodsList.value = resData.order.itemList
    }
  } catch {}
}
onMounted(() => {
  getDetail()
  getGoodsList()
})
</script>
<style scoped lang="less">
@selectors: 500, 4, 8 1px, 14px, 13px, 48px, 60px, 80px, 14px, 230px, auto, 15px 2px, 3px, 4px, 5px, 8px, 10px, 12px,
  15px, 16px, 18px, 20px, 22px, 25px, 30px, 32px, 35px, white;
@safe-bottom: constant(safe-area-inset-bottom);
@safe-bottom: env(safe-area-inset-bottom);
each(@selectors, {
  .font-@{value}{
    font-weight : @value;
  }
  .leading-@{value} {
    line-height: @value;
  }
  .bg-@{value} {
    background-color: @value;
  }

  .rounded-@{value} {
      border-radius: @value;
  }
  .text-@{value} {
      font-size: @value;
  }
  .w-@{value} {
    width: @value;
  }
  .h-@{value} {
    height: @value;
  }
  .mt-@{value} {
    margin-top: @value;
  }

  .ml-@{value} {
    margin-left: @value;
  }

  .mr-@{value} {
    margin-right: @value;
  }

  .mb-@{value} {
    margin-bottom: @value;
  }
  .mx-@{value} {
    margin-left: @value;
    margin-right: @value;
  }
  .my-@{value} {
    margin-top: @value;
    margin-bottom: @value;
  }

  .pt-@{value} {
    padding-top: @value;
  }

  .pl-@{value} {
    padding-left: @value;
  }

  .pr-@{value} {
    padding-right: @value;
  }

  .px-@{value} {
    padding-left: @value;
    padding-right: @value;
  }
  .py-@{value} {
    padding-top: @value;
    padding-bottom: @value;
  }

  .p-@{value} {
       padding: @value;
  }
  .m-@{value} {
    margin: @value;
  }
});
// .page-box {
//   background-image: url('/@/assets/img/insurance-bg.png');
//   background-size: contain;
//   background-position: top;
//   // background-color: red;
// }
.fixIphonex {
  padding-bottom: calc(@safe-bottom + 10px) !important;
  &::after {
    content: '';
    position: fixed;
    bottom: 0 !important;
    left: 0;
    height: calc(@safe-bottom + 1px);
    width: 100%;
    background: #ffffff;
  }
}
.flex {
  display: flex;
}
.flex-1 {
  flex: 1;
}
.justify-between {
  justify-content: space-between;
}
.justify-center {
  justify-content: center;
}
.items-center {
  align-items: center;
}
.flex-col {
  flex-direction: column;
}
.text-center {
  text-align: center;
}
.bg-F7F8FA {
  background-color: #f7f8fa;
}
.rounded-full {
  border-radius: 50%;
}
.text-999 {
  color: #999;
}
.text-666 {
  color: #999;
}
.w-full {
  width: 100%;
}
.page-box {
  position: relative;
  z-index: 1;
  // padding-top: 100px;
}
.insurance-bg {
  width: 100vw;
  position: absolute;
  z-index: -1;
}
.page-content {
  padding-top: 100px;
}
// .item-box {
//   position: relative;
//   top:100px;
// }
</style>
